<div class="spo-detail-header grid-container">
  @if (isEditPage) {
    <div class="spo-page-status">Edit</div>
  }
  <div class="spo-detail-header-title grid-item" data-cy="spo-detail-page-spo-number">SPO {{spoDetails.number}}</div>
  <div [ngClass]="['spo-detail-header-status', 'grid-item', 'header-status', spoDetails.status.code]"
  data-cy="spo-detail-page-spo-status">{{spoDetails.status.code}}</div>
  @if (!isEditPage) {
    <div class="grid-item">
      <span class="spo-detail-header-menu" ngbDropdown data-cy="spo-detail-element-menu">
        <app-tooltip [dynamic]="false" message="SPO actions" class="display-inline-flex">
          <span class="iwp-icon-gen_kontextmenu" ngbDropdownToggle></span>
        </app-tooltip>
        <div ngbDropdownMenu id="override-dropdown-position">
          @if (userService.hasPermissions([Permission.PARTNER_SPO_SEND])) {
            <div data-cy="spo-list-element-menu-submit"
              [class.disable]="disableContextMenuSend()"
              (click)="clickContextMenuSend()"
            ngbDropdownItem>{{spoActionsUtilService.getContextMenuSendButtonText(contextMenuOptions.canRetry)}}</div>
          }
          @if (!isEditPage && userService.hasPermissions([Permission.PARTNER_SPO_EDIT])) {
            <div
              [class.disable]="!contextMenuOptions.canEdit"
              data-cy="spo-list-element-menu-edit"
              (click)="contextMenuOptions.canEdit && clickContextMenuEdit()"
            ngbDropdownItem>Edit</div>
          }
          <div class="separator"></div>
          @if (userService.hasPermissions([Permission.PARTNER_SPO_DELETE])) {
            <div data-cy="spo-list-element-menu-delete"
              [class.disable]="!contextMenuOptions.canDelete"
              (click)="contextMenuOptions.canDelete && clickContextMenuDelete()"
            ngbDropdownItem>Delete</div>
          }
        </div>
      </span>
    </div>
  }
</div>

<div class="spo-status-display">
  @for (group of [materialStatus, materialAlerts]; track group; let isLastGroup = $last) {
    @for (status of group; track status; let isLast = $last) {
      <app-single-material-status [isDisabled]="disableStatusGroup()"
        [retryClick]="statusRetryActions.get(status.status.code)"
        [specialOrderMaterialGroupStatus]="status"
      [totalOfMaterials]="spoDetails.numberOfMaterials"></app-single-material-status>
      @if (!isLast) {
        <div class="status-separator"></div>
      }
    }
    @if (!isLastGroup) {
      <div class="group-separator"></div>
    }
  }
</div>
